var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTownHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 27940 21590",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_630839136"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M18207 7263c0,-410 23,-737 23,-1146l7552 0 0 12485 -7575 0 0 -11339zm-7879 -1146l0 0 7341 0 0 12485 -7341 0 0 -12485zm-7832 0l0 0 7294 0 0 12485 -7294 0 0 -12485zm0 -538l0 0c25,-21 -8,1 40,-29 18,-12 41,-24 61,-33l3677 -1889c36,-9 133,18 242,69l3205 1484c216,100 325,182 529,87l3686 -1692c298,-133 355,-26 523,46l3207 1470c428,175 472,291 790,129 83,-42 163,-74 242,-108l3273 -1497 3764 1940 -23239 23zm21322 -1652l0 0 631 320 0 -1005 -631 0 0 685zm-15547 -78l0 0c0,106 528,296 631,351l0 -982 -561 0c-54,0 -70,16 -70,70l0 561zm7832 -678l0 0 0 608 607 257 0 -865 -607 0zm-351 421l0 0 -1223 -550c-135,-61 -263,-104 -320,-104 -251,0 -188,-8 -467,117l-3601 1662c-93,36 -217,-41 -312,-88 -107,-55 -195,-86 -304,-141 -111,-56 -201,-84 -296,-148 0,-304 0,-607 0,-911 0,-185 51,-562 -374,-562 -415,0 -803,-87 -916,277 -39,125 -19,417 -19,589l-1195 -543c-412,-187 -357,-249 -948,82l-4115 2105c-258,132 -569,217 -569,483 0,335 534,257 842,257l0 12555c0,123 76,264 136,331 76,85 199,136 355,136l23449 0c592,0 444,-782 444,-1239l24 -11783c230,0 841,71 841,-280 0,-222 -289,-332 -498,-437l-1886 -943c0,-319 -1,-639 0,-958 0,-167 12,-327 -56,-436 -151,-243 -531,-172 -926,-172 -113,0 -302,107 -326,282 -19,147 -2,444 -2,606 -245,-130 -1390,-748 -1473,-748 -206,0 -414,154 -671,264l-3061 1406c-56,28 -97,31 -134,14l-1090 -515c0,-296 -1,-592 0,-888 1,-188 16,-257 -76,-369 -171,-208 -445,-146 -836,-146 -483,0 -397,563 -397,795z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M11450 14347l1824 0 0 2034 -1824 0 0 -2034zm0 -1146l0 0 1824 0 0 678 -1824 0 0 -678zm-467 0l0 0 0 3180c0,238 191,444 420,444l1894 0c193,0 421,-168 421,-351l0 -3343c0,-183 -208,-398 -491,-398l-1730 0c-278,0 -514,198 -514,468z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M11450 8899l1824 0 0 2034 -1824 0 0 -2034zm0 -1145l0 0 1824 0 0 678 -1824 0 0 -678zm-467 23l0 0 0 3156c0,260 179,444 467,444l1847 0c193,0 421,-167 421,-350l0 -3320c0,-189 -172,-397 -351,-397l-1987 0c-225,0 -397,208 -397,467z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M19422 14347l1847 0 0 2034 -1847 0 0 -2034zm0 -1146l0 0 1847 0 0 678 -1847 0 0 -678zm-444 70l0 0 0 3039c0,146 28,289 99,369 63,70 194,146 322,146l1847 0c292,0 468,-176 468,-468l0 -3179c0,-130 -68,-238 -134,-311 -64,-70 -209,-134 -334,-134l-1777 0c-335,0 -491,200 -491,538z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M14700 14347l1847 0 0 2034 -1847 0 0 -2034zm0 -1146l0 0 1847 0 0 678 -1847 0 0 -678zm-444 23l0 0 0 3157c0,251 192,444 444,444l1823 0c286,0 468,-183 468,-444l0 -3157c0,-303 -188,-491 -491,-491l-1753 0c-303,0 -491,188 -491,491z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M8691 16382l-1731 0c-50,-6 5,5 -41,-7 -66,-18 -8,11 -51,-25 -44,-40 -7,25 -25,-43 -32,-130 5,-1981 6,-1986l1860 8 9 1960c-2,33 -3,32 -10,61l-17 32zm-1823 -3181l0 0 1823 0 0 678 -1823 0 0 -678zm-468 47l0 0 0 3086c0,296 169,491 468,491l1847 0c251,0 444,-216 444,-468l0 -3109c0,-307 -208,-515 -514,-515l-1730 0c-307,0 -515,208 -515,515z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M22696 14347l1823 0 0 2034 -1823 0 0 -2034zm0 -1146l0 0 1823 0 0 678 -1823 0 0 -678zm-445 -47l0 0 0 3273c0,221 201,398 421,398l1917 0c154,0 374,-190 374,-351l0 -3390c0,-180 -255,-351 -444,-351l-1777 0c-271,0 -491,183 -491,421z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M14700 8899l1847 0 0 2034 -1847 0 0 -2034zm0 -1145l0 0 1847 0 0 678 -1847 0 0 -678zm-444 0l0 0 0 3179c0,234 184,444 420,444l1894 0c262,0 421,-198 421,-467l0 -3133c0,-255 -146,-467 -397,-467l-1941 0c-233,0 -397,212 -397,444z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M19422 8899l1847 0 0 2034 -1847 0 0 -2034zm0 -1145l0 0 1847 0 0 678 -1847 0 0 -678zm-444 70l0 0 0 3039c0,299 131,514 421,514l1894 0c250,0 421,-208 421,-467l0 -3133c0,-253 -186,-467 -374,-467l-2011 0c-109,0 -211,92 -262,159 -63,84 -89,212 -89,355z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M8691 10938l-1613 -4c-76,1 -156,10 -210,-24 -21,-23 -28,-2 -31,-115l14 -1917 1856 7c34,169 9,1442 11,1815l-27 238zm-1823 -3184l0 0 1823 0 0 678 -1823 0 0 -678zm-468 47l0 0 0 3086c0,146 49,272 118,349 68,75 186,141 326,141l1871 0c266,0 444,-217 444,-490l0 -3086c0,-229 -163,-491 -374,-491l-2011 0c-211,0 -374,262 -374,491z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M22696 8899l1823 0 0 2034 -1823 0 0 -2034zm0 -1145l0 0 1823 0 0 678 -1823 0 0 -678zm-445 -70l0 0 0 3296c0,220 201,397 421,397l1894 0c212,0 397,-177 397,-350l0 -3390c0,-133 -163,-327 -374,-327l-1987 0c-161,0 -351,220 -351,374z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M3595 14347l1847 0 0 2034 -1847 0 0 -2034zm0 -1146l0 0 1847 0 0 678 -1847 0 0 -678zm-444 -23l0 0 0 3226c0,234 186,421 420,421l1871 0c192,0 421,-168 421,-351l0 -3343c0,-243 -218,-398 -468,-398l-1753 0c-274,0 -491,179 -491,445z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M3595 8899l1847 0 0 2034 -1847 0 0 -2034zm0 -1145l0 0 1847 0 0 678 -1847 0 0 -678zm-444 -24l0 0 0 3227c0,235 172,420 444,420l1870 0c189,0 398,-171 398,-350l0 -3367c0,-164 -187,-350 -351,-350l-2011 0c-91,0 -194,76 -245,129 -57,60 -105,184 -105,291z",
    fill: "#808080"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTownHouse);
export default __webpack_public_path__ + "static/media/town-house.0df0cacd0b04f6fd0e856b7f498cbe8c.svg";
export { ForwardRef as ReactComponent };